import React from 'react'
import PropTypes from 'prop-types';
import { Link } from 'react-router-dom';
import Servbg from '../../../assets/images/about-hero.png';

const Servicedtlbred = ({ title }) => {
    return (
        <div
            className="inner-page-hero"
            style={{
                backgroundImage: `url(${Servbg})`,
                
            }}
        >
            <div className="container">
                <div className="hero-heading-title">
                    <h2>{title}</h2>
                </div>
                {/* <ul className="bradcrumb">
                    <li>
                        <Link to="/">Home</Link>
                    </li>
                    <li>
                        <Link to="/Services1">Services </Link>
                    </li>
                    <li>
                        <Link to="#">Mortgage Loans</Link>
                    </li>
                </ul> */}
            </div>
        </div>

    )
}
Servicedtlbred.propTypes = {
    title: PropTypes.string.isRequired
};
export default Servicedtlbred;